import React from 'react';
import { ArrowDownIcon, ArrowRightIcon, CheckIcon, StoreIcon } from 'lucide-react';
import { beginnerSteps, beginnerTools } from '../data/content';
import { Eyebrow, Mark, SectionLead, SectionTitle } from './ui/Section';
export function Beginners() {
  return <section className="border-y border-slate-200 bg-white px-4 py-12 md:py-16" data-id="element-21" data-mp="1xumqqj8unzlx">
      <div className="mx-auto max-w-5xl" data-id="element-22" data-mp="22pikbntqiv15">
        <Eyebrow data-id="element-23" data-mp="1p08cmk022v4e">🪚 ¿Nunca hiciste un mueble?</Eyebrow>
        <SectionTitle data-id="element-24" data-mp="1oynhot9txa60">
          Podés comenzar con <span className="text-sky-600" data-id="element-25" data-mp="1tqf20m2e6jnp">proyectos simples.</span>
        </SectionTitle>
        <SectionLead data-id="element-26" data-mp="1f1snunoi3xy2">
          No hace falta empezar construyendo un placard enorme. Tampoco necesitás tener un taller
          profesional. Muchos de los proyectos están pensados a partir de:
        </SectionLead>

        <ul className="mx-auto mt-6 grid max-w-3xl grid-cols-2 gap-2 md:grid-cols-4" data-id="element-27" data-mp="160kpk5lzix3z">
          {beginnerTools.map(tool => <li key={tool} className="flex items-center gap-2 rounded-lg bg-sky-50 px-3 py-2 text-sm font-bold text-slate-800" data-id="element-28" data-mp="1a1edv03cadxe">
              <CheckIcon className="h-4 w-4 shrink-0 text-sky-600" data-id="element-29" data-mp="8o74xauk7nzz" />
              {tool}
            </li>)}
        </ul>

        <p className="mx-auto mt-6 flex max-w-2xl items-start gap-3 rounded-2xl border-2 border-yellow-300 bg-yellow-50 p-4 text-left text-sm font-semibold leading-relaxed text-slate-700 md:text-base" data-id="element-30" data-mp="njmzri2yrnxf">
          <StoreIcon className="mt-0.5 h-5 w-5 shrink-0 text-slate-900" data-id="element-31" data-mp="3r26k7yfehpho" />
          <span data-id="element-32" data-mp="3m3d9gdri0cl7">
            Y si no querés realizar los cortes vos misma/o, podés llevar la{' '}
            <Mark data-id="element-33" data-mp="4mc74gbu7sqy">lista de medidas a una maderera</Mark> y pedir las piezas ya cortadas.
          </span>
        </p>

        <ol className="mt-8 grid gap-3 md:grid-cols-4" data-id="element-34" data-mp="3vzzr6toj2nj0">
          {beginnerSteps.map(([number, title, text], index) => <li key={number} className="relative flex flex-col items-center rounded-2xl border border-slate-200 bg-slate-50 p-5 text-center" data-id="element-35" data-mp="3892om7imh2kf" data-mpi={index}>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-sky-600 text-base font-black text-white" data-id="element-36" data-mp="3szq3s30t7c1t">
                {number}
              </span>
              <p className="mt-3 text-sm font-black uppercase tracking-wide text-slate-900 md:text-base" data-id="element-37" data-mp="5o6zbkhqfdde">
                {title}
              </p>
              <p className="mt-1 text-sm font-semibold leading-snug text-slate-600" data-id="element-38" data-mp="ao33pkucd6th">{text}</p>
              {index < beginnerSteps.length - 1 && <>
                  <ArrowRightIcon className="absolute -right-3 top-1/2 hidden h-5 w-5 -translate-y-1/2 text-sky-600 md:block" aria-hidden="true" data-id="element-39" data-mp="3e3h6h70hb8s1" />
                  <ArrowDownIcon className="absolute -bottom-2.5 left-1/2 h-5 w-5 -translate-x-1/2 text-sky-600 md:hidden" aria-hidden="true" data-id="element-40" data-mp="3o2g6y2b3by3y" />
                </>}
            </li>)}
        </ol>

        <p className="mt-8 text-center text-base font-black uppercase text-slate-900 md:text-xl" data-id="element-41" data-mp="2nrx020k026cs">
          Proyectos domésticos simples, funcionales y fáciles de entender.
        </p>
      </div>
    </section>;
}